import * as Yup from "yup";
import * as React from "react";
import { useFormik } from "formik";
import { Address } from "@/types/index";
import styles from "./styles.module.css";
import { FormError, Button, FormSelect } from "@/components/Shared";

const AddressForm: React.FC<{
	addresses: Address[];
	setAddress: React.Dispatch<React.SetStateAction<Address[]>>;
}> = ({ addresses, setAddress }) => {
	const [loading, setLoading] = React.useState<Boolean>(false);

	const addressOptionsList = addresses.map((address) => {
		return address.formatted_address.filter((str) => str !== "").join(", ");
	});

	const formik = useFormik({
		initialValues: {
			address: "",
		},
		validationSchema: Yup.object({
			address: Yup.number().required("Please select an address."),
		}),
		onSubmit: (values: any) => {
			setLoading(true);
			setAddress([addresses[values.address]]);
			setLoading(false);
		},
	});

	return (
		<form onSubmit={formik.handleSubmit}>
			<div className="row mt-4">
				<div className="col-12">
					<div className={`${styles.input__fixed} mx-auto`}>
						<FormSelect
							handleChange={formik.handleChange}
							name="address"
							value={formik.values.address}
							optionsList={addressOptionsList}
							placeholder="Please select an address..."
						/>
						{formik.touched.address && formik.errors.address ? (
							<FormError message="Please select an address." theme="dark" />
						) : null}
					</div>
				</div>
			</div>
			<div className="row mt-4">
				<div className="col-12">
					<div className={`${styles.input__fixed} mx-auto`}>
						<Button
							type="submit"
							name="button"
							title="Select"
							isLoading={loading}
						/>
					</div>
				</div>
			</div>
		</form>
	);
};

export default AddressForm;
